import { CheckCircle, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_270b8cc9-1693-407c-b15e-5414d2b83f2e/artifacts/qe9vta95_LOGO-FIRMA-PNG-1-branco-258x278-1%20%282%29.png";
const SCHEDULING_URL = "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3Q7zlIOjDtOwt8Yh9UkWimN2NZwA2epFz1w3c6dvFtBZQOi5Z-nOrv9rbjInNGZjQ6hxS638aN?gv=true";

export default function ThankYouPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="thank-you-page">
      {/* Header */}
      <header className="py-6 border-b border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <img 
              src={LOGO_URL} 
              alt="Firma Medical Growth" 
              className="h-12 w-auto invert"
            />
            <span className="text-sm font-medium text-[#0A0A0A]">
              Medical Growth Systems
            </span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Success Message */}
          <div className="text-center mb-8">
            <div className="mb-6 checkmark-animation" data-testid="success-icon">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-[#0A0A0A] rounded-full">
                <CheckCircle className="w-10 h-10 text-white" />
              </div>
            </div>

            <h1 className="heading-lg mb-4" data-testid="thank-you-headline">
              Application Received!
            </h1>
            
            <p className="body-lg text-[#6B7280]" data-testid="thank-you-subheadline">
              Schedule your strategy call below.
            </p>
          </div>

          {/* Google Calendar Appointment Scheduling Embed */}
          <div data-testid="scheduling-container">
            <iframe
              src={SCHEDULING_URL}
              title="Schedule your strategy call"
              style={{ width: '100%', minWidth: '320px', height: '700px', border: 0 }}
              frameBorder="0"
              data-testid="scheduling-widget"
            />
          </div>

          {/* Return Link */}
          <div className="text-center mt-8">
            <Link 
              to="/"
              className="inline-flex items-center gap-2 text-sm text-[#6B7280] hover:text-[#0A0A0A] transition-colors"
              data-testid="return-home"
            >
              <ArrowLeft className="w-4 h-4" />
              Return to Homepage
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 border-t border-[#E5E7EB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs text-[#6B7280]">
            © {new Date().getFullYear()} Firma Medical Growth Systems. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
